<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                <el-breadcrumb-item>雾炮管理</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <!-- <span>设备名称：</span>
                <el-input placeholder="请输入设备名称" v-model="tableDataName"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                <el-button type="primary" @click="addRow()">添加设备</el-button>-->
                <el-button type="primary" @click="addRow()">绑定设备</el-button>
            </div>
            <div class="build-table">
                <el-table :data="tableDataEnd" ref="tableDataBegin" style="width: 100%;" border>
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80" type="index"></el-table-column>
                <el-table-column label="序列号">
                    <template slot-scope="scope">
                    <span>{{ scope.row.sn }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="雾炮位置">
                    <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="项目名称">
                    <template slot-scope="scope">
                    <span>{{ scope.row.projectName }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="是否有雾炮">
                    <template slot-scope="scope">
                    <span v-if="scope.row.fogFlag=='0'" style="color:red;">无</span>
                    <span v-else style="color:#36C635;">有</span>
                    </template>
                </el-table-column>-->
                <el-table-column label="雾炮状态">
                    <template slot-scope="scope">
                    <span>{{scope.row.status}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>

                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                    
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="200px"
                    :label-position="labelPosition"
                    :rules="rules"
                    >
                    <el-form-item label="位置描述：">
                        <el-input
                        v-model="addForm.name"
                        placeholder="请输入"
                        autocomplete="off"
                        style="width:216px;"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="序列号：" prop="sn">
                        <el-input
                        v-model="addForm.sn"
                        placeholder="请输入设备编号"
                        autocomplete="off"
                        style="width:216px;"
                        ></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="是否有雾炮：">
                        <el-radio v-model="addForm.fogFlag" label="1" style="margin-right:20px;">有</el-radio>
                        <el-radio v-model="addForm.fogFlag" label="0">无</el-radio>
                    </el-form-item>-->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
                </el-table>

                <!-- 表单列表 -->
                <!-- <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[3, 5, 10]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>-->
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
export default {
    data() {
    return {
      projectId: '',
      crane: [
        { val: '1', perName: '海智' },
        { val: '2', perName: '瞳声' }
      ],
      perName: '1',
      addLoading: false,
      dialogTitle: '编辑窗口', //弹出框标题
      labelPosition: 'right',
      groupId: util.session.get('groupId'),

      addForm: {
        useType: '1',
        id: '',
        fogName: '',
        projectName: '',
        sn: '',
        fogFlag: '1'
      },
      editForm: [],
      radio: 1,
      search: '',
      searchData: '',
      addFormVisible: false,
      editFormVisible: false,
      tableDataName: '',
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      filterTableDataEnd: [],
      flag: false,
      dataText: '数据加载中...',
      rules: {
        sn: [{ required: true, message: '请输入设备编号', trigger: 'blur' }]
      }
    }
  },
  watch: {
    groupId: {
      handler(newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted() {
    this.getData()
      
  },
  methods: {
    // 搜索数据 111
    doFilter() {
      this.currentPage = 1
      this.currentChangePage()
      this.flag = true
    },
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`)
    //   this.currentPage = val
    //   this.getData()
    // },
    // // 监控当前页码
    // currentChangePage() {
    //   this.getData()
    // },

    // 获取数据
    getData() {
      var option = {
        projectId: util.session.get('groupId'),
        useType: this.addForm.useType
      }
      var that = this
      // getFogList
      myHttp.secRelayByUserType(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            console.log(resp)
            var list = resp.data.data.list || []
            that.tableDataEnd = list
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑信息'
      this.addFormVisible = true
      this.addForm.id = row.sn
      this.addForm.name = row.name
      // this.addForm.sprayName = row.sprayName
      this.addForm.sn = row.sn
      // this.addForm.sprayFlag = row.sprayFlag
      ;(this.addForm.projectName = row.projectName),
        (this.addForm.useType = '2')
    },

    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          myHttp.deleteRelayInfo({
            id: row.id
          }).then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          // that.addForm.projectId = that.groupId
          //修改
          if (that.addForm.id == '') {
              myHttp.configurationRelayById({
                useType: '2',
                projectId: that.groupId,
                name: that.addForm.name,
                id: that.addForm.sn
              })
              .then(
                function(resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('添加成功')
                    that.addFormVisible = false
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function() {}
              )
          } else {
              myHttp.updateRelayById({
                name: that.addForm.name,
                id: that.addForm.id
              }).then(
                function(resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('修改成功')
                    that.addFormVisible = false
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function() {}
              )
          }
        }
      })
    },
    cancel() {
      this.addFormVisible = false
      this.editFormVisible = false
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    /**
     * 新增设备
     */
    addRow() {
      // debugger
      this.dialogTitle1 = '新增设备'
      ;(this.addFormVisible = true),
        (this.addForm = {
          name: '',
          useType: '2',
          description: '',
          id: '',
          // projectName: '',
          projectId: util.session.get('groupId')
        })
    }
  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 8vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-bar .btnLef {
        position: absolute;
        right: 6%;
        display: block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 4px;
        background: #ffaf15;
        border: 1px solid #ffb800;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 8vh );
    }

    .el-table .el-table-column:not(:first-child) {
        border: 1px solid slategrey;
    }

    .el-table >>> .cell {
        overflow: hidden;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
    }

    .add-form {
        margin-top: 10vh;
    }

    .add-form .el-form-item {
        margin-top: 30px;
    }

    .el-pagination {
        padding: 20px 0;
    }
</style>